import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const Social3D = () => {
  return (
    <span className='flex space-x-5 justify-center items-center social-3d'>
      <a
        href='https://www.facebook.com/JackpotPartyCasinoCommunity'
        target='_blank'
        aria-label="facebook"
      >
        <StaticImage src='../images/social-3d/facebook.png' alt='' width={70} />
      </a>
      <a href='https://www.instagram.com/jackpotparty/' target='_blank' aria-label="instagram">
        <StaticImage
          src='../images/social-3d/instagram.png'
          alt=''
          width={70}
        />
      </a>
      <a href='https://twitter.com/JackpotParty' target='_blank' aria-label="twitter">
        <StaticImage src='../images/social-3d/twitter.png' alt='' width={70} />
      </a>
      <a href='https://www.tiktok.com/@jackpot.party.casino' target='_blank' aria-label="tiktok">
        <StaticImage src='../images/social-3d/tiktok.png' alt='' width={70} />
      </a>
      <a
        href='https://www.youtube.com/channel/UCw4WCXeA-t7K1XgNawtQ8Ug'
        target='_blank'
        aria-label="youtube"
      >
        <StaticImage src='../images/social-3d/youtube.png' alt='' width={70} />
      </a>
    </span>
  )
}

export default Social3D
